<template>
    <div id="no_data">
        <div class="no_data">
            <img :src="noData[noIndex].img" alt="">
            {{ noData[noIndex].content }}
            <div class="no_data1" @click="toCreate" v-if="noData[noIndex].btn"> {{ noData[noIndex].btn }}</div>
        </div>
    </div>
</template>
<script>
import data from '@/assets/data';

export default {
    props: {
        noIndex: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            noData: data.noData
        }
    },
    methods:{
        toCreate() {
            this.$emit('toCreate')
        },
    }
}
</script>

<style>
#no_data {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.no_data {
    display: flex;
    flex-flow: column;
    align-items: center;
    font-size: 15px;
    color: #333333;
}

.no_data img {
    width: 168px;
    height: 95px;
    margin-bottom: 7px;
}

.no_data1 {
    width: 133px;
    height: 33px;
    line-height: 33px;
    text-align: center;
    background: linear-gradient(93deg, #FFB400 0%, #FF6603 100%);
    font-size: 15px;
    color: #FFFFFF;
    border-radius: 6px;
    margin: 0 auto;
    margin-top: 15px;
    cursor: pointer;
}
</style>